import { createAction, props } from '@ngrx/store';
import { ITable } from '@common/models/table';
import { IContext } from '@context/models/context'
import { DashboardItem } from '@dashboards/models/dashboard-item';


export const loadExternal = createAction(
    '[Payment To You Table] External Load',
    props<{ accountRef: number, widget: DashboardItem }>()
);
export const loadInternal = createAction(
    '[Payment To You Table] Internal Load',
    props<{ context: IContext, widget: DashboardItem }>()
);
export const loadComplete = createAction(
    '[Payment To You Table] Load Complete',
    props<{ payload: ITable, widget: DashboardItem }>()
);

